import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { BookState } from '@/store/types/book.state';

export const getters: GetterTree<BookState, RootState> = {

};